import { jsx } from "panel";
import {
  RetentionCountType,
  RowLabelType
} from "common/query-builder/query-entry-section/types";
import { QueryBlockEl } from "common/query-builder/query-block";
import { ButtonSize } from "common/components/button/constants";
import { SelectTheme } from "common/components/select/constants";
import { ChartType, ReportName, ResourceType, RETENTION_MATH_TYPES } from "common/report/constants";
import { renameEvent } from "common/query-builder/cohorts-query-builder/util";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/row-types/base/query-entry-section-el";
import { BaseEntryRowEl } from "common/query-builder/query-entry-section/row-types/base/template";
import { dataGroupStore } from "common/report/stores/data-groups";
import { Placement } from "common/components/tooltip/types";
import { RetentionCriteriaEl } from "common/report/retention/query-builder/retention-criteria";
import { RetentionQuerySettingsEl } from "common/report/retention/query-builder/retention-query-settings";
import { MetricType } from "common/query-builder/query-block/constants";
export function RetentionMetricEntryRowEl({ section, entry, index }) {
  const behaviorRenderer = () => /* @__PURE__ */ jsx("div", {
    sel: ".mp-metric-entry-behavior"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    key: "funnelEntries",
    attrs: {
      ...section.helpers.getNestedSectionAttrs(),
      elref: `entrySection`,
      autofocus: true,
      "autoactivate-placeholders": true,
      "disable-add-entry": true,
      "min-entries": 2,
      "row-draggable": true,
      "row-types": [ResourceType.Event],
      "row-label-type": RowLabelType.Numeric,
      "report-name": ReportName.Retention,
      "show-all-events": false,
      "show-top-events": false,
      "show-sessions": false,
      entries: entry.behavior.behaviors.map((behavior) => ({
        entryIndexLabelToggle: entry.behavior.entryIndexLabelToggle,
        event: {
          custom: behavior.type === MetricType.CustomEvent,
          id: behavior.id,
          label: renameEvent(behavior.name) || `Select Step`,
          renamed: behavior.renamed,
          value: behavior.name
        },
        filters: behavior.filters,
        filtersDeterminer: behavior.filtersDeterminer,
        type: ResourceType.Event
      }))
    },
    on: {
      update: this.handleEntryUpdate
    }
  }), /* @__PURE__ */ jsx(null, null, entry.behavior.retentionType === `birth` ? /* @__PURE__ */ jsx(RetentionCriteriaEl, {
    attrs: {
      unbounded: entry.behavior.retentionUnbounded,
      "retention-unit": entry.behavior.retentionUnit,
      "bucket-sizes": entry.behavior.retentionCustomBucketSizes,
      "retention-alignment-type": entry.behavior.retentionAlignmentType,
      "data-group-id": entry.behavior.dataGroupId
    },
    on: {
      changeSetting: this.handleSettingsChanged,
      changeUnit: this.handleRetentionUnitChanged,
      applyBucketSizes: this.handleBucketSizesApplied,
      "toggle-retention-alignment": this.handleToggleRetentionAlignment
    }
  }) : /* @__PURE__ */ jsx(RetentionQuerySettingsEl, {
    attrs: {
      "retention-type": entry.behavior.retentionType,
      "counting-method": this.getCountingMethod()
    },
    on: { change: this.handleSettingsChanged }
  })));
  const measurementRenderer = () => /* @__PURE__ */ jsx("div", {
    sel: ".mp-metric-entry-measurement"
  }, /* @__PURE__ */ jsx(QueryBlockEl, {
    sel: ".count-menu",
    attrs: {
      elref: `countBlock`,
      type: `count`,
      "metric-type": MetricType.Retention,
      "data-group-id": entry.behavior.dataGroupId || ``,
      "data-groups": Object.values(dataGroupStore.value),
      "project-id": section.attr(`project-id`),
      "selector-type": `button`,
      selected: {
        countType: entry.measurement.aggregationOperator === RETENTION_MATH_TYPES.RETENTION_RATE ? RetentionCountType.RetentionRate : RetentionCountType.Unique
      },
      "advanced-menu-sections": section.attr(`chart-type`) === ChartType.Line || section.attr(`chart-type`) === ChartType.Metric ? [
        {
          label: `Retention groups`,
          icon: `info-xs`,
          tooltip: {
            "max-width": `120px`,
            placement: Placement.Right,
            text: `View how specific Retention Groups trend over time. [Learn more](https://docs.mixpanel.com/docs/analysis/reports/retention#retention-trends)`
          },
          items: entry.measurement.retentionBuckets
        }
      ] : [],
      "highlight-selections": true,
      theme: SelectTheme.QueryBuilder,
      "button-size": ButtonSize.Small,
      "track-name": `retention`,
      "user-id": section.attr(`user-id`),
      "workspace-id": section.attr(`workspace-id`)
    },
    on: {
      select: this.handleRetentionCountBySelected
    }
  }));
  return /* @__PURE__ */ jsx(BaseEntryRowEl, {
    el: section,
    entry,
    index,
    showLabels: false,
    hideActions: true,
    rowRenderer: {
      selectorRenderer: behaviorRenderer,
      bodyRowRenderer: measurementRenderer
    },
    isPlaceholder: this.isPlaceholder()
  });
}
